import Address from '../../AddressBuilder'
import HttpConfig from '../../../request/HttpConfig'

const _path = {
  sfrz: Address.business('kxsfrz', Address.CONFIG.VERSION.version_1),
}

export default {

  cardno(_parameter) { // 身份认证
    let _action = 'cardnoCertification'
    if (_parameter.faceImg) _action = 'cardnoAndFaceCertification'
    return sHttp.postJson(_path.sfrz + _action, _parameter)
  }
  ,
  HttpConfig
}
